// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__216ya","left":"styles_left__2MPOR"};